import { useQuery } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../../axiosInstance";
import { CompanyTermsTypes } from "../../../components/Models/CompanyTerms";

interface UseGetCompanyTermsByUserProps {
  userId: string;
  enabled?: boolean;
}

export function useGetCompanyTermsByUser({
  userId,
  enabled = true,
}: UseGetCompanyTermsByUserProps) {
  return useQuery({
    enabled: enabled && !!userId,
    queryKey: ["company-terms", userId],
    queryFn: async () => {
      return axiosInstance<CompanyTermsTypes[]>(
        getAPIURL(`/MuslimInvestProfile/CompanyTerms/by-user/${userId}`)
      ).then((response) => response.data);
    },
  });
}
